export const SOS_NOTICE_LIST = "SOS_NOTICE_LIST";
export const SOS_NOTICE_COMMENT = "SOS_NOTICE_COMMENT";
export const SOS_AS_LIST = "SOS_AS_LIST";
export const SOS_AS_COMMENT = "SOS_AS_COMMENT";
export const BLOCKED_USER = "BLOCKED_USER";
export function sosListSet(storageName: string, idx: string | undefined) {
  let sosList: { list: string[] } | undefined;
  if (window.localStorage.getItem(storageName)) {
    sosList = JSON.parse(window.localStorage.getItem(storageName)!);
  }
  sosList?.list
    ? window.localStorage.setItem(storageName, JSON.stringify({ list: [...sosList.list, idx] }))
    : window.localStorage.setItem(storageName, JSON.stringify({ list: [idx] }));
}

export function sosListDelete(storageName: string, idx: string | undefined) {
  let sosList: { list: string[] } | undefined;
  if (window.localStorage.getItem(storageName)) {
    sosList = JSON.parse(window.localStorage.getItem(storageName)!);
  }
  const temp = sosList?.list.filter((e) => e !== idx);
  window.localStorage.setItem(storageName, JSON.stringify({ list: temp }));
  return temp;
}

export const sosContentSet = (storageName: string, idx: string) => {
  if (window.confirm("해당 댓글을 신고하시겠습니까?")) {
    let sosList: { comment: string[] | undefined } | undefined;
    if (window.localStorage.getItem(storageName)) {
      sosList = JSON.parse(window.localStorage.getItem(storageName)!);
    }
    sosList?.comment
      ? window.localStorage.setItem(storageName, JSON.stringify({ comment: [...sosList?.comment, idx] }))
      : window.localStorage.setItem(storageName, JSON.stringify({ comment: [idx] }));
    window.location.reload();
  }
};
